import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';		// map, tap, catchError, first

import { FireUserService } from "../../../modulo-comunes/servicios/fire-user-servicios";
import { DataUserService } from "../../../modulo-comunes/servicios/data-user-servicios";
import { FuncionesService } from "../../../modulo-comunes/servicios/funciones-servicios";
import { FechaHoraService } from "../../../modulo-comunes/servicios/fechahora-servicios";
import { MuestraService } from "../../../modulo-comunes/servicios/muestra-servicios";
import { LogService } from "../../../modulo-comunes/servicios/log-servicios";
import { DataEmpresaService } from "../../../modulo-comunes/servicios/data-empresa-servicios";
import { UserAut, User } from '../../../modulo-comunes/interfaces/user-interfaces';

@Component({
  selector: 'app-nuevo-usr',
  templateUrl: './nuevo-usr.component.html',
  styleUrls: ['./nuevo-usr.component.css']
})
export class NuevoUsrComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();
  formNuevoUsr = this.fb.group({
    fTxtCliente: ["", [Validators.required, Validators.minLength(5)]],
    fTxtCedula: ["", [Validators.required, Validators.minLength(5)]],
    fTxtContacto: ["", [Validators.required, Validators.minLength(3)]],
    fTxtTelfContacto: ["", [Validators.required, Validators.minLength(5)]],
    fTxtDirUsr: ["", [Validators.required, Validators.minLength(5)]],
    fTxtMail: ["", [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-]{2,8}$")]],
    fTxtPwd: ["", [Validators.required, Validators.minLength(8), Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z\\d]).{8,}$")]],
    fTxtPwd2: ["", [Validators.required, Validators.minLength(8), Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z\\d]).{8,}$")]],
    fChkAcepto: ["", [Validators.requiredTrue]]
  });

  modeloUsrAnt = {}; //para evitar que presionen Crear varias veces y se intente la misma creación
  modeloUsrNue = {};
  //En este programa voy a usar la técnica del form, no la del modelo. Para no causar confusión, la fuente real de 
  //los datos del form va a ser formCambioPwd, pero voy a usar modeloRegistro para guardar los datos como variables. 
  modeloRegistro = {
    cliente: '',
    cedula: '',
    contacto: '',
    telfContacto: '',
    dirUsr: '',
    mail: '',
    pwd: '',
    pwd2: '',
    acepto: false,
    userYaCargado: this.dataUserService.userYaCargado,
    empresa: ''
  };
  mensajeRegistro: string = '';
  mensajeRegistro2: string = '';

  yaLogin = false;
  okAcepto = false;
  formOk = false;
  formError = false;
  formDuplic = false;
  srcLogo: string;
  userAutActual: UserAut;
  userActual: User;
  sitio: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private fireUserService: FireUserService,
    private dataUserService: DataUserService,
    private funcionesService: FuncionesService,
    private fechaHoraService: FechaHoraService,
    private muestraService: MuestraService,
    private logService: LogService,
    public dataEmpresaService: DataEmpresaService
  ) {
    this.logService.consoleLog('2', "PC NU userYaCargado: " + this.dataUserService.userYaCargado);
    this.logService.consoleLog('2', "PC NU user: " + this.dataUserService.user.nombre);
    this.logService.consoleLog('2', "PC NU userAut: " + this.dataUserService.userAut.nombre);
    if (this.dataUserService.userYaCargado) {
      this.logService.consoleLog('2', 'PC NU Usuario ya cargado: ' + this.dataUserService.user.email);
    }
  }

  ngOnInit() {
    this.sitio = this.dataEmpresaService.sitioElegido;
    if (this.sitio == 'EasyMed') {
      this.srcLogo = "assets/images/EMlogo2.svg";
    } else if (this.sitio == 'Efisys') {
      this.srcLogo = "assets/images/logo-efisys2.svg";
    }

    this.ocultaTopBar();
    this.ocultaFooter();
    this.modeloRegistro.mail = '';   //"ortegalopez111@gmail.com";
    //this.loginSubmit();
  }

  ngOnDestroy(): void {
    //Esta técnica de this._onDestroy$ en ngOnDestroy
    //permite liberar todos los Observables que tengan un .takeUntil(this._onDestroy$)
    //Si un Observable tiene take(n) no requiere destruirse porque ya lo hace luego de leer n veces
    this.muestraTopBar();
    this.muestraFooter();
    this.modeloRegistro.mail = '';   //"ortegalopez111@gmail.com";
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  public findInvalidControls(f: FormGroup): string[] {
    return this.funcionesService.findInvalidControls(f);
  }

  public chkValido(f: FormGroup, nombre: string): boolean {
    return this.funcionesService.chkValido(f, nombre);
  }

  public asignaEstiloBody(): object {
    let estBody: object = {};
    if (this.sitio == 'EasyMed') {
      estBody = { "background-image": "url('/assets/images/36918105_xl_1280x853.png')" };
    } else if (this.sitio == 'Efisys') {
      estBody = { "background-image": "url('/assets/images/tienda.png')" };
    }
    return estBody;
  }

  asignaEstiloLogo(): object {
    let estLogo: object = {};
    if (this.sitio == 'EasyMed') {
      estLogo = {};
    } else if (this.sitio == 'Efisys') {
      estLogo = { "height": "67px" };
    }
    return estLogo;
  }

  public asignaEstilo(f: FormGroup, nombre: string): object {
    return this.funcionesService.asignaEstilo(f, nombre);
  }

  public asignaEstiloSubmitDisabled(f: FormGroup): object {
    return this.funcionesService.asignaEstiloSubmitDisabled(f);
  }

  togglePwd() {
    const p = (<HTMLInputElement>document.getElementById("fTxtPwd"));
    const p2 = (<HTMLInputElement>document.getElementById("fTxtPwd2"));
    const t = (<HTMLInputElement>document.getElementById("btnTogglePwd"));
    if (p.type === "password") {
      p.type = "text";
      p2.type = "text";
      t.textContent = "Ocultar password";
    } else {
      p.type = "password";
      p2.type = "password";
      t.textContent = "Ver password";
    }
  }

  clickChkAcepto(event) {
    if (event.target.checked) {
      this.okAcepto = true;
    } else {
      this.okAcepto = false;
    }
  }

  ocultaTopBar() {
    this.logService.consoleLog('2', "PC NU ocultaTopBar");
    if (
      document.getElementById("navbar-1").className.match(/navbar w-nav/)
    ) {
      document.getElementById("navbar-1").className = "navbar-oculta";
    }
  }

  ocultaFooter() {
    this.logService.consoleLog('2', "PC NU ocultaFooter");
    //document.getElementById("boton").classList.toggle("active");
    if (
      document.getElementById("footer-1").className.match(/diag-wrapper/)
    ) {
      document.getElementById("footer-1").className = "footer-oculto";
    }
  }

  muestraTopBar() {
    this.logService.consoleLog('2', "PC NU muestraTopBar");
    if (
      document.getElementById("navbar-1").className.match(/navbar-oculta/)
    ) {
      document.getElementById("navbar-1").className = "navbar w-nav";
    }
  }

  muestraFooter() {
    this.logService.consoleLog('2', "PC NU muestraFooter");
    if (
      document.getElementById("footer-1").className.match(/footer-oculto/)
    ) {
      document.getElementById("footer-1").className = "diag-wrapper";
    }
  }

  nuevoUsrSubmit() {
    //esto es copiado del onSubmitCambioPwd, evita que se envíe el mismo form varias veces
    this.logService.consoleLog('2', 'PC NU ' + JSON.stringify(this.formNuevoUsr.value));
    this.modeloRegistro.mail = this.formNuevoUsr.value.fTxtMail;
    this.modeloRegistro.pwd = this.formNuevoUsr.value.fTxtPwd;
    this.modeloRegistro.pwd2 = this.formNuevoUsr.value.fTxtPwd2;

    this.modeloUsrNue = JSON.parse(JSON.stringify(this.formNuevoUsr.value));
    if (this.funcionesService.deepEqual(this.modeloUsrNue, this.modeloUsrAnt)) {
      this.logService.consoleLog('2', "PC NU Ya se envió esta solicitud");
      this.formDuplic = true;
      setTimeout(() => {
        this.formDuplic = false;
      }, 5000);
    } else {
      this.muestraService.muestraLoading(true);
      this.logService.consoleLog('2', "PC NU Primer envío");
      this.logService.consoleLog('2', 'PC NU nuevoUsr: ' + this.modeloRegistro.mail);
      this.modeloUsrAnt = this.modeloUsrNue;
      if (this.dataUserService.userYaCargado) {
        //no viene por aquí porque si ya ingresó ya no muestro el registro
        this.logService.consoleLog('2', 'PC NU registro, user ya cargado: ' + this.modeloRegistro.mail);
      } else {
        this.logService.consoleLog('2', 'PC NU registro, primera carga: ' + this.modeloRegistro.mail);
        if (this.funcionesService.compareStr(this.modeloRegistro.pwd, this.modeloRegistro.pwd2)) {
          this.fireUserService.afRegistrar(this.modeloRegistro.mail, this.modeloRegistro.pwd)
            .then(value => {
              this.logService.consoleLog('2', 'PC NU registro, uid: ' + value.user.uid + ', email verificado: ' + value.user.emailVerified);
              this.fireUserService.verifyMail$()
                .then(() => {
                  this.logService.consoleLog('2', 'PC NU mail de verificación ok')
                })
                .catch(err => {
                  this.logService.consoleLog('9', 'PC NU Error en mail de verificación')
                  this.logService.consoleLog('9', 'PC NU ' + err.code);
                  this.logService.consoleLog('9', 'PC NU ' + err.message);
                });
              //independiente del verifyMail, creo el userAut en userAut/easymed con autorizado='N'
              //Cambio a autorizado='S' para q pueda ingresar sin necesidad de que ST lo autorice
              this.userAutActual = {
                uid: value.user.uid,
                email: value.user.email, 
                autorizado: 'S', 
                nombre: this.formNuevoUsr.value.fTxtCliente,
                cedula: this.formNuevoUsr.value.fTxtCedula, 
                contacto: this.formNuevoUsr.value.fTxtContacto,
                telfContacto: this.formNuevoUsr.value.fTxtTelfContacto, 
                dirUsr: this.formNuevoUsr.value.fTxtDirUsr,
                acepto: this.formNuevoUsr.value.fChkAcepto, 
                fechaHora: this.fechaHoraService.formatFecha(new Date()) + "-" + this.fechaHoraService.formatHora(new Date())
              };
              this.fireUserService.createFireUserAut$(this.userAutActual)
                .then(() => {
                  this.logService.consoleLog('2', 'PC NU Crear UserAut ok')
                  //pongo los mensajes aquí y no arriba en verifyMail porque esa llamada tiene Async-Await y va a esperar hasta enviar el mail
                  //en este punto sí crear directo el usuario en arpsa/usuarios/datos pero un admin debe poner  
                  //Autorizado = S. Crear un pantalla para ver los usr nuevos con Autorizado=N y emailVerified=S
                  this.userActual = {
                    uid: value.user.uid, 
                    email: value.user.email, 
                    nombre: this.formNuevoUsr.value.fTxtCliente, 
                    cedula: this.formNuevoUsr.value.fTxtCedula,
                    contacto: this.formNuevoUsr.value.fTxtContacto, 
                    telfContacto: this.formNuevoUsr.value.fTxtTelfContacto,
                    dirUsr: this.formNuevoUsr.value.fTxtDirUsr, 
                    acepto: this.formNuevoUsr.value.fChkAcepto,
                    fechaHora: this.fechaHoraService.formatFecha(new Date()) + "-" + this.fechaHoraService.formatHora(new Date()),
                    foto: '', 
                    tipoUsuario: 'Usuario', 
                    extraSize: '0px'
                  };

                  this.logService.consoleLog('2', 'PC NU Crear Usuario ok')
                  this.mensajeRegistro = 'Le hemos enviado un e-mail, dé clic en el enlace para confirmar su correo.';
                  this.mensajeRegistro2 = 'Luego con el botón Solicitar del Login puede pedir la creación o el acceso a una empresa.';

                  this.muestraService.muestraLoading(false);
                  this.muestraService.muestraMsgbox('NU-001: Usuario creado', this.mensajeRegistro, this.mensajeRegistro2, 'Aceptar', 'ThumbsUp')
                    .pipe(take(1))
                    .subscribe(r => {
                      this.logService.consoleLog('2', 'PC NU Respuesta: ' + r)
                    });

                  //En este momento todavía no puedo crear el Usr porque no sé en qué empresa va a trabajar
                  //El usr debe comunicarse con un Admin de su empresa y pedir q le activen, 
                  //el Admin usa una pantalla que permite poner Autorizado = S y crear el usr

                  /*
                    this.fireUserService.createFireUser$(this.userActual)
                    .then(() => {
                    })
                    .catch(err => {
                      this.logService.consoleLog('9', 'PC NU Error al crear Usuario')
                      this.logService.consoleLog('9', 'PC NU ' + err.code);
                      this.logService.consoleLog('9', 'PC NU ' + err.message);
                    });
                  */

                })
                .catch(err => {
                  this.muestraService.muestraLoading(false);
                  this.logService.consoleLog('9', 'PC NU Error al crear userAut')
                  this.logService.consoleLog('9', 'PC NU ' + err.code);
                  this.logService.consoleLog('9', 'PC NU ' + err.message);
                })
            })
            .catch(err => {
              this.muestraService.muestraLoading(false);
              this.mensajeRegistro = 'Problema al registrar nuevo usuario.';
              this.logService.consoleLog('9', 'PC NU Problema al registrar nuevo usuario')
              this.logService.consoleLog('9', 'PC NU ' + err.code);
              this.logService.consoleLog('9', 'PC NU ' + err.message);
              switch (err.code) {
                case 'auth/invalid-email':
                  this.mensajeRegistro2 = 'El e-mail no es válido, por favor revíselo.';
                  break;
                case 'auth/operation-not-allowed':
                  this.mensajeRegistro2 = 'El usuario está inhabilitado, por favor comuníquese con el administrador de la empresa';
                  break;
                case 'auth/email-already-in-use':
                  this.mensajeRegistro2 = 'Este usuario ya existe, si no recuerda la contraseña puede restablecerla dando clic en el enlace a la izquierda.';
                  break;
                case 'auth/weak-password':
                  this.mensajeRegistro2 = 'La contraseña debe tener por lo menos 6 caracteres.';
                  break;
                case 'auth/user-disabled':
                  this.mensajeRegistro2 = 'El usuario está inhabilitado, por favor comuníquese con el administrador de la empresa';
                  break;
                case "auth/network-request-failed":
                  this.mensajeRegistro2 = 'Error de red: timeout, no se puede contactar el host, no hay Internet, etc.';
                  break;
                default:
                  this.mensajeRegistro2 = err.message;
                  break;
              }
              this.muestraService.muestraMsgbox('NU-002: Problema al crear el usuario', this.mensajeRegistro, this.mensajeRegistro2, 'Aceptar', 'Error')
                .pipe(take(1))
                .subscribe(r => {
                  this.logService.consoleLog('2', 'PC NU Respuesta: ' + r)
                });
            });
        } else {
          this.mensajeRegistro = 'Error en el password:';
          this.mensajeRegistro2 = 'Los dos valores son distintos. Por favor verifíquelos.';
          this.muestraService.muestraLoading(false);
          this.muestraService.muestraMsgbox('NU-003: Atención!', this.mensajeRegistro, this.mensajeRegistro2, 'Aceptar', 'Error')
            .pipe(take(1))
            .subscribe(r => {
              this.logService.consoleLog('2', 'PC NU Respuesta: ' + r)
            });
        }
      }
    }
  }
}
